import { StateCreator } from "zustand";
import { Location } from "history";
import cloneDeep from "lodash.clonedeep";

interface DesktopHistory {
  GRID1: string[];
  GRID2: string[];
  GRID3: string[];
}

interface GoTo {
  GRID1?: string | string[];
  GRID2?: string | string[];
  GRID3?: string | string[];
}

interface GoBack {
  GRID1?: number;
  GRID2?: number;
  GRID3?: number;
}

export interface NavigationSlice {
  navigation: {
    redirect: {
      location: Location<unknown> | null;
      triggered: boolean;
      event: boolean;
    };
    desktopHistory: DesktopHistory;
    setDesktopHistory: ({ goTo, goBack }: { goTo?: GoTo; goBack?: GoBack }) => () => void;
    setRedirect: (props: Partial<NavigationSlice["navigation"]["redirect"]>) => void;
  };
}

const createNavigationSlice: StateCreator<NavigationSlice, [], [], NavigationSlice> = (set) => ({
  navigation: {
    redirect: {
      location: null,
      triggered: false,
      event: false,
    },
    desktopHistory: {
      GRID1: ["groups"],
      GRID2: [],
      GRID3: [],
    },
    setDesktopHistory:
      ({ goTo = {}, goBack = {} }) =>
      () =>
        set((state) => {
          const history = state.navigation.desktopHistory;
          const updateHistory = cloneDeep(state.navigation.desktopHistory);

          for (const key of Object.keys(history)) {
            const gridName = key as keyof DesktopHistory;
            // Go back in history the amount present in [goBack] for the corresponding grid
            if (goBack[gridName]) {
              updateHistory[gridName] = history[gridName].slice(0, history[gridName].length - goBack[gridName]!);
            }

            // Add the new path if there is one
            if (goTo[gridName]) {
              if (typeof goTo[gridName] === "string") {
                updateHistory[gridName] = [...updateHistory[gridName]!, goTo[gridName]! as string];
              } else {
                updateHistory[gridName] = [...updateHistory[gridName]!, ...goTo[gridName]!];
              }
            }
          }

          return {
            navigation: {
              ...state.navigation,
              desktopHistory: updateHistory,
            },
          };
        }),
    setRedirect: (props) =>
      set((state) => ({
        navigation: {
          ...state.navigation,
          redirect: { ...state.navigation.redirect, ...props },
        },
      })),
  },
});

export default createNavigationSlice;
